import type { AppRouteRecordRaw } from '@/router/types'

export const marketingSystemRoutes: AppRouteRecordRaw[] = [
  {
    path: 'trafficAlliance',
    name: 'trafficAlliance',
    redirect: '/trafficAlliance/trafficProduct',
    meta: {
      title: '流量联盟'
    },
    children: [
      {
        path: 'trafficProduct',
        name: 'trafficProduct',
        component: () => import('@/views/marketingSystem/trafficProductNew/index.vue'),
        meta: {
          title: '联盟产品'
        }
      },
      // {
      //   path: 'carLoanProduct',
      //   name: 'carLoanProduct',
      //   component: () => import('@/views/marketingSystem/carLoanProduct/index.vue'),
      //   meta: {
      //     title: '车贷产品'
      //   }
      // },
      // {
      //   path: 'customerPlatform',
      //   name: 'customerPlatform',
      //   component: () => import('@/views/marketingSystem/customerPlatform/index.vue'),
      //   meta: {
      //     title: '获客平台'
      //   }
      // },
      // {
      //   path: 'trafficMatrix',
      //   name: 'trafficMatrix',
      //   component: () => import('@/views/marketingSystem/trafficMatrix/index.vue'),
      //   meta: {
      //     title: '流量矩阵'
      //   }
      // },
      {
        path: 'invalidCustomerCheck',
        name: 'InvalidCustomerCheck',
        component: () => import('@/views/marketingSystem/InvalidCustomerCheck/index.vue'),
        meta: {
          title: '无效客户检测'
        }
      }
    ]
  },
  // {
  //   path: 'trafficProduct',
  //   name: 'trafficProduct',
  //   component: () => import('@/views/marketingSystem/trafficProduct/index.vue'),
  //   meta: {
  //     title: '联盟产品'
  //   }
  // },
  // {
  //   path: 'customerPlatform',
  //   name: 'customerPlatform',
  //   component: () => import('@/views/marketingSystem/customerPlatform/index.vue'),
  //   meta: {
  //     title: '获客平台'
  //   }
  // },
  // {
  //   path: 'trafficMatrix',
  //   name: 'trafficMatrix',
  //   component: () => import('@/views/marketingSystem/trafficMatrix/index.vue'),
  //   meta: {
  //     title: '流量矩阵'
  //   }
  // },
  {
    path: 'ryhPlatform',
    name: 'ryhPlatform',
    redirect: '/ryhPlatform/productManage',
    meta: {
      title: '融逸花'
    },
    children: [
      {
        path: 'productManage',
        name: 'productManage',
        component: () => import('@/views/marketingSystem/productManage/index.vue'),
        meta: {
          title: '推广产品'
        }
      }
    ]
  }
  // {
  //   path: 'marketingSystem',
  //   name: 'MarketingSystem',
  //   component: () => import('@/views/marketingSystem/index.vue'),
  //   meta: {
  //     title: '营销系统'
  //   },
  //   children: [
  //     {
  //       path: 'productManage',
  //       name: 'productManage',
  //       component: () => import('@/views/marketingSystem/productManage/index.vue'),
  //       meta: {
  //         title: '产品推广'
  //       }
  //     }
  //   ]
  // }
]
